module.exports = __webpack_public_path__ + "static/media/ca.ce143108.svg";